<script setup lang="ts">
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'

const emptyResponse = inject('emptyResponse')
const specResponse = inject('specResponse')
const { t } = useI18n()
</script>

<template>
  <IDSKRow>
    <IDSKCol variant-desktop="two-thirds">
      <div class="graySection mt-9 mb-8">
        <IDSKHeading as="h3" variant="m">{{
          t('zoppm.step0.graySection.mainHeading')
        }}</IDSKHeading>

        <DisplayList bold="title">
          <dt>{{ t('zoppm.step0.graySection.kodVyzvy') }}</dt>
          <dd class="mb-3">{{ emptyResponse.vyzvaRef?.kod }}</dd>
          <dt>{{ t('zoppm.step0.graySection.nazov') }}</dt>
          <dd class="mb-3">{{ emptyResponse?.vyzvaRef?.nazov }}</dd>
          <dt>{{ t('zoppm.step0.graySection.oblast') }}</dt>
          <dd class="mb-3">{{ specResponse?.opatrenie?.oblastUplnyNazov }}</dd>
          <dt>{{ t('zoppm.step0.graySection.komponent') }}</dt>
          <dd class="mb-3">{{ specResponse?.opatrenie?.komponentUplnyNazov }}</dd>
          <dt>{{ t('zoppm.step0.graySection.opatrenie') }}</dt>
          <dd>{{ specResponse?.opatrenie?.opatrenieUplnyNazov }}</dd>
        </DisplayList>
      </div>
    </IDSKCol>
  </IDSKRow>
</template>

<style lang="scss" scoped>
.graySection {
  padding: 5px 5px;
  background-color: var(--idsk-color-lighter-grey);
  dt {
    color: var(--idsk-color-dark-grey);
    font-weight: bold;
  }
}
</style>
